const testing = {
  cApiDomain: '//c.didi-food.com',
  actApiDomain: '//act-api.didi-food.com',
  entregaApiDomain: '//entrega.didi-food.com'
}

export default testing
